import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import callAuthApi from "../common/AuthAPIClient";
import { getAuth } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [entitlements, setEntitlements] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const token = await firebaseUser.getIdToken();
        setUser({ ...firebaseUser, token });
         // ✅ Fetch entitlements from your backend using the token
         try {
          const response = await callAuthApi({
            url: "/entitlements/" + firebaseUser.email,
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {}
          });
          console.log('response')
          console.log(response)
          const { permissions } = response;
          setEntitlements(permissions); // adjust if your structure is different

          // Optional: Store in localStorage
          localStorage.setItem("permissions", JSON.stringify(permissions));
        } catch (err) {
          console.error("Failed to fetch entitlements", err);
          setEntitlements([]); // fallback to empty
        }
      } else {
        setUser(null);
        setEntitlements(null);
        localStorage.removeItem("permissions");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, entitlements, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
